import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "d-flex mb-2 px-2 justify-content-between w-100" };
const _hoisted_2 = {
    style: { "font-size": "12px" },
    class: "mb-0 audio-name flex-grow-1"
};
const _hoisted_3 = { class: "bg-white px-4 d-flex align-items-center shadow-lg player-container" };
const _hoisted_4 = { class: "position-relative" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = {
    key: 1,
    class: "d-flex flex-column align-items-center"
};
const _hoisted_7 = { class: "py-2 gap-2 d-flex flex-column align-items-center" };
const _hoisted_8 = ["onClick"];
import AudioPlayer from 'vue3-audio-player';
import { computed, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
export default /*@__PURE__*/ _defineComponent({
    __name: 'MaterialAudioPlayerCard',
    setup(__props) {
        const store = useStore();
        const userToken = computed(() => store.getters.getToken);
        const companyId = computed(() => store.getters.getCompany);
        const userId = computed(() => store.getters.getId);
        const audioPlayerPosition = computed(() => store.getters.getAudioPlayerPosition);
        const audioData = computed(() => store.getters.getAudioData);
        const selectContainerPosition = ref(null);
        const audioIsRunning = ref(false);
        const downloadingData = ref(false);
        const audioSelectOptionsState = ref(false);
        const selectInSpeedMode = ref(false);
        const audioPlayer = ref();
        const velocityAvaliable = [2.0, 1.50, 1.00, 0.50];
        const handleDownloadingDataState = () => {
            downloadingData.value = !downloadingData.value;
        };
        const downloadAudioFile = async () => {
            handleSelectOptionState();
            if (downloadingData.value) {
                store.dispatch('toastfy/activeErrorNotification', { text: "Aguarde o Download Anterior!" });
                return;
            }
            await handleDownloadingDataState(true);
            const payload = {
                requestData: {
                    fileURL: audioData?.value?.audio || null,
                    userId: userId.value,
                    companyId: companyId.value.id
                },
                userToken: userToken.value
            };
            const blobResponse = await store.dispatch('downloadMaterialItemFile', payload);
            const url = window.URL.createObjectURL(blobResponse);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${audioData.value?.name || 'AudioFile'}'`);
            document.body.appendChild(link);
            link.click();
            store.dispatch('toastfy/activeSuccesNotification', { text: "Download realizado!" });
            await handleDownloadingDataState(false);
            setTimeout(() => {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }, 100);
        };
        const handleSelectOptionState = async (state) => {
            state && (await calcSelectPosition());
            audioSelectOptionsState.value = state;
            !selectInSpeedMode.value && (handleSelectInSpeedMode(false));
        };
        const handleSelectInSpeedMode = async (state) => {
            selectInSpeedMode.value = state;
        };
        const handleAudioIsRunningState = () => {
            audioIsRunning.value = !audioIsRunning.value;
            audioIsRunning.value && audioPlayer ? audioPlayer.value.play()
                : audioPlayer.value.pause();
        };
        const changeVelocity = (velocity) => {
            const wrapper = document.querySelector('.audio__player');
            if (wrapper) {
                const audioEL = wrapper?.querySelector('audio');
                if (audioEL) {
                    audioEL.playbackRate = velocity;
                    handleSelectInSpeedMode(false);
                    handleSelectOptionState(false);
                }
            }
        };
        const calcSelectPosition = () => {
            const audioElement = document.querySelector('.audio-player-container');
            if (audioElement) {
                const audioElementPosition = audioElement.getBoundingClientRect();
                selectContainerPosition.value = audioElementPosition.top > window.innerHeight / 2
                    ? { bottom: '100%', right: '100%' }
                    : { top: '100%', right: '100%' };
            }
        };
        const closeAudioPlayer = () => {
            store.dispatch('setAudioData');
        };
        onMounted(() => {
            calcSelectPosition();
        });
        watch(audioPlayerPosition, () => {
            calcSelectPosition();
        });
        watch(audioData, () => {
            audioIsRunning.value && (handleAudioIsRunningState());
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                style: _normalizeStyle({ left: audioPlayerPosition.value?.left || 0, top: audioPlayerPosition.value?.top || 0 }),
                class: "position-fixed w-25 audio-player-container"
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("p", _hoisted_2, _toDisplayString(audioData.value?.name || 'Audio sem nome'), 1),
                    _createElementVNode("i", {
                        onClick: _withModifiers(closeAudioPlayer, ["stop"]),
                        class: "bi bi-x-lg cursor-pointer"
                    })
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("i", {
                        style: { "font-size": "20px" },
                        onClick: _withModifiers(handleAudioIsRunningState, ["stop"]),
                        class: _normalizeClass([audioIsRunning.value ? 'bi-pause-fill' : 'bi-play-fill', 'bi cursor-pointer'])
                    }, null, 2),
                    _createElementVNode("div", {
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"])),
                        class: "flex-grow-1"
                    }, [
                        _createVNode(_unref(AudioPlayer), {
                            style: { "font-size": "12px" },
                            ref_key: "audioPlayer",
                            ref: audioPlayer,
                            option: { src: `${audioData.value.audio || ''}` }
                        }, null, 8, ["option"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("i", {
                            style: { "font-size": "16px" },
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (handleSelectOptionState(!audioSelectOptionsState.value)), ["stop"])),
                            class: "bi bi-three-dots-vertical cursor-pointer"
                        }),
                        (audioSelectOptionsState.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                style: _normalizeStyle(selectContainerPosition.value),
                                class: "shadow px-4 rounded-2 py-2 position-absolute bg-white options-select"
                            }, [
                                (!selectInSpeedMode.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _createElementVNode("div", {
                                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (handleSelectInSpeedMode(!selectInSpeedMode.value)), ["stop"])),
                                            class: "d-flex option cursor-pointer"
                                        }, [...(_cache[4] || (_cache[4] = [
                                                _createElementVNode("i", {
                                                    style: { "font-size": "12px", "color": "gray" },
                                                    class: "bi me-2 bi-fast-forward-fill"
                                                }, null, -1),
                                                _createElementVNode("p", {
                                                    style: { "font-size": "12px", "color": "gray" },
                                                    class: "mb-0"
                                                }, "Velocidade", -1)
                                            ]))]),
                                        _createElementVNode("div", {
                                            onClick: _withModifiers(downloadAudioFile, ["stop"]),
                                            class: "d-flex option cursor-pointer"
                                        }, [...(_cache[5] || (_cache[5] = [
                                                _createElementVNode("i", {
                                                    style: { "font-size": "12px", "color": "gray" },
                                                    class: "bi me-2 bi-download"
                                                }, null, -1),
                                                _createElementVNode("p", {
                                                    style: { "font-size": "12px", "color": "gray" },
                                                    class: "mb-0"
                                                }, "Download", -1)
                                            ]))])
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                        _createElementVNode("i", {
                                            onClick: _cache[3] || (_cache[3] = ($event) => (handleSelectInSpeedMode(false))),
                                            class: "cursor-pointer bi bi-arrow-left-square"
                                        }),
                                        _createElementVNode("div", _hoisted_7, [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(velocityAvaliable, (velocity) => {
                                                return _createElementVNode("p", {
                                                    class: "mb-0 cursor-pointer",
                                                    style: { "font-size": "12px", "color": "gray" },
                                                    onClick: ($event) => (changeVelocity(velocity))
                                                }, _toDisplayString(velocity) + "x", 9, _hoisted_8);
                                            }), 64))
                                        ])
                                    ]))
                            ], 4))
                            : _createCommentVNode("", true)
                    ])
                ])
            ], 4));
        };
    }
});
